/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Storage_Notice_StrongInputs */

const en_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files are permanently removed after 14 days.`)
};

const fr_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les fichiers sont definitivement supprimes apres 14 jours.`)
};

const de_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Dateien werden nach 14 Tagen endgültig gelöscht.`)
};

const it_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I file vengono rimossi definitivamente dopo 14 giorni.`)
};

const ru_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файлы удаляются безвозвратно через 14 дней.`)
};

const es_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los archivos se eliminan de forma permanente después de 14 días.`)
};

const zh_cn2_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件将在 14 天后永久删除。`)
};

const ja_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルは 14 日後に完全に削除されます。`)
};

const hi_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फाइलें 14 दिनों के बाद स्थायी रूप से हटा दी जाती हैं।`)
};

const pt_pt2_embed_captions_storage_notice_strong = /** @type {(inputs: Embed_Captions_Storage_Notice_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os arquivos são removidos permanentemente após 14 dias.`)
};

/**
* | output |
* | --- |
* | "Files are permanently removed after 14 days." |
*
* @param {Embed_Captions_Storage_Notice_StrongInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_storage_notice_strong = /** @type {((inputs?: Embed_Captions_Storage_Notice_StrongInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Storage_Notice_StrongInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_storage_notice_strong(inputs)
	if (locale === "de") return de_embed_captions_storage_notice_strong(inputs)
	if (locale === "it") return it_embed_captions_storage_notice_strong(inputs)
	if (locale === "ru") return ru_embed_captions_storage_notice_strong(inputs)
	if (locale === "es") return es_embed_captions_storage_notice_strong(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_storage_notice_strong(inputs)
	if (locale === "ja") return ja_embed_captions_storage_notice_strong(inputs)
	if (locale === "hi") return hi_embed_captions_storage_notice_strong(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_storage_notice_strong(inputs)
	return en_embed_captions_storage_notice_strong(inputs)
});